import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Nav from './Nav';
import Search from '../blocks/Search';
import { LOCATION } from '../../utils/Constants';


class Header extends Component {
  state = {
    showMobileMenu: false,
    imageStatus: 'loading'
  }
  handleMobileClick = (e) => {
    if(e){
      e.preventDefault();
    }
    
    this.setState({
      showMobileMenu: !this.state.showMobileMenu
    })
  }
  
  render(){
    let showSearch = true;
    let menuClass = '';
    let mobileMenuClass = '';
    let searchClass = '';
    if(this.state.showMobileMenu){
      menuClass = 'show';
      mobileMenuClass = 'active';
    }
    if(window.location.pathname.indexOf('/details') > -1 || window.location.pathname.indexOf('/pdetails') > -1) {
      searchClass = 'on-map'
    }
    if(window.location.pathname.indexOf('/getfound') > -1 || window.location.pathname.indexOf('/sitemap') > -1) {
      searchClass = 'hidden';
    }
    // if(window.location.pathname.indexOf('/details') > -1 || window.location.pathname.indexOf('/pdetails') > -1 || window.location.pathname.indexOf('/getfound') > -1 || window.location.pathname.indexOf('/sitemap') > -1){
    //   showSearch = false;
    // }
    return(
      <header className="header-main">
        <div className="row header-wrapper">
          <div className="medium-7 columns logo-wrapper">
            <h1 className="main-title"><Link to="/">{LOCATION} <span className="standout-light">Online</span></Link></h1>

            <Search 
              searchClass={searchClass}
            />
            
              <a 
                href='/' 
                className={`mobile-menu ${mobileMenuClass}`}
                onClick={this.handleMobileClick}
                >
                  <span className="span-1"></span>
                  <span className="span-2"></span>
                  <span className="span-3"></span>
              </a>
          </div>
          <div className="medium-5 columns">
            <Nav
              handleMobileClick={this.handleMobileClick}
              menuClass={menuClass}
            />
          </div>
        </div>
        
      </header>
    );
  }
}
export default Header;


// WEBPACK FOOTER //
// ./src/components/sections/Header.js